import { DataTable, Loader } from "@/components";
import useTaskConfig from "./useSchool_Reports";
import { Button } from "@/components/ui";
import { filter } from "@/assets";
import { Filter } from "./Filter";
import useSchool_Reports from "./useSchool_Reports";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui";

const School_Reports = () => {
  const {
    columns,
    onAdd,
    openDeleteDialog,
    setOpenDeleteDialog,
    openDialog,
    setOpenDialog,
    dialogData,
    onCancelFilter,
    onFilterBtnClick,
    onRowClick,
    openFilter,
    filterData,
    setFilterData,
    onFilterApply,
    tasksData,
    pageNumber,
    pageSize,
    totalPages,
    totalRecords,
    setPageNumber,
    setPageSize,
    isLoading,
    error,
    isDeleting,
    handleDownloadExcel,
    isExcelDownloading,
  } = useSchool_Reports();

  return (
    <>
      <div className="mb-4 px-5 flex justify-end gap-4">
        <Button type="button" variant="ghost" onClick={onFilterBtnClick}>
          <img src={filter} alt="Filter icon" />
          Filter
        </Button>

        <button
          className="cursor-pointer text-primary flex items-center gap-1"
          onClick={handleDownloadExcel}
          disabled={isExcelDownloading}
        >
          {/* Download Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
            />
          </svg>
          {isExcelDownloading ? "Downloading..." : "Download Excel"}
        </button>
      </div>

      {isLoading ? (
        <div className="flex justify-center items-center h-64">
          <Loader />
        </div>
      ) : error ? (
        <div className="flex justify-center items-center h-64">
          <p className="text-red-500">Error loading tasks: {error.message}</p>
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={tasksData}
          onRowClick={onRowClick}
          serviceSidePagination={false}
          pageNumber={pageNumber} // Use 0-based pageNumber
          pageSize={pageSize}
          totalPages={totalPages}
          totalRecords={totalRecords}
          setPageNumber={setPageNumber} // Directly set pageNumber
          setPageSize={setPageSize} // Directly set pageSize
        />
      )}

      {openFilter && (
        <Filter
          onCancel={onCancelFilter}
          filterData={filterData}
          setFilterData={setFilterData}
          onApply={onFilterApply}
        />
      )}

      <Dialog open={openDialog} onOpenChange={setOpenDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>{dialogData.title}</DialogTitle>
          </DialogHeader>
          <div className="space-y-2 mt-2">
            {dialogData.values.map((val, idx) => (
              <div key={idx} className="font-semibold">{val}</div>
            ))}
          </div>
          <div className="flex justify-end mt-4">
            <Button onClick={() => setOpenDialog(false)}>Close</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default School_Reports;